<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商品管理</el-breadcrumb-item>
      <el-breadcrumb-item>添加商品</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图 -->
    <el-card>
      <!-- 提示区域 -->
      <el-alert title="添加商品信息" type="info" center show-icon :closable="false"> </el-alert>
      <!-- 步骤条区域 -->
      <el-steps :space="200" :active="activeIndex - 0" finish-status="success" align-center>
        <el-step title="基本信息"></el-step>
        <!-- <el-step title="商品规格"></el-step> -->
        <!-- <el-step title="商品属性"></el-step> -->
        <el-step title="商品图片"></el-step>
        <el-step title="商品详情"></el-step>
        <el-step title="完成"></el-step>
      </el-steps>

      <!-- tab栏区域 -->
      <!-- label-position="top" -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="150px">
        <el-tabs v-model="activeIndex" :tab-position="'left'" :before-leave="beforeTabLeave" @tab-click="tabClicked">
          <el-tab-pane label="基本信息" name="0" style="width: 800px">
            <el-form-item label="商品名称" prop="title">
              <el-input v-model="addForm.title"></el-input>
            </el-form-item>
            <el-form-item label="商品编码" prop="number">
              <el-input v-model="addForm.number"></el-input>
            </el-form-item>
            <!-- <el-form-item label="是否学标" prop="taxRate">
              <el-select v-model="addForm.school_sign" placeholder="请选择">
                <el-option value="1">是</el-option>
                <el-option value="2">否</el-option>
              </el-select>
            </el-form-item> -->
             <el-form-item label="经销渠道" prop="taxRate">
              <!-- <el-radio v-model="addForm.unit" label=1>件</el-radio>
              <el-radio v-model="addForm.unit" label=2>组</el-radio> -->
              <el-select v-model="addForm.jxtype" placeholder="请选择">
                <el-option
                  v-for="item in jxtypelist"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="用户级别" prop="level">
              <el-input v-model="addForm.level"></el-input>
            </el-form-item>
            <el-form-item label="一级价格" prop="price1">
              <el-input v-model="addForm.price1"></el-input>
            </el-form-item>
            <el-form-item label="二级价格" prop="price2">
              <el-input v-model="addForm.price2"></el-input>
            </el-form-item>
            <el-form-item label="三级价格" prop="price3">
              <el-input v-model="addForm.price3"></el-input>
            </el-form-item> -->
            <el-form-item label="是否学标" prop="taxRate">
              <!-- <el-radio v-model="addForm.unit" label=1>件</el-radio>
              <el-radio v-model="addForm.unit" label=2>组</el-radio> -->
              <el-select v-model="addForm.school_sign" placeholder="请选择">
                <el-option
                  v-for="item in xuebiao"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <!--
            <el-form-item label="库存预警" prop="warnNum">
              <el-input v-model="addForm.warnNum"></el-input>
            </el-form-item>

            <el-form-item label="商品库存" prop="kucun">
              <el-input v-model="addForm.kucun"></el-input>
            </el-form-item> -->

            <el-form-item label="规格" prop="preNum">
              <el-input v-model="addForm.preNum"></el-input>
            </el-form-item>

            <el-form-item label="单位（件/组）" prop="taxRate">
              <!-- <el-radio v-model="addForm.unit" label=1>件</el-radio>
              <el-radio v-model="addForm.unit" label=2>组</el-radio> -->
              <el-select v-model="addForm.unit" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="重量系数（每件/组重量kg）" prop="weight">
              <el-input v-model="addForm.weight"></el-input>
            </el-form-item>

            <el-form-item label="商品单价(元)" prop="price">
              <el-input v-model="addForm.price"></el-input>
            </el-form-item>

            <!-- <el-form-item label="商品活动" prop="a_id">
              <el-select v-model="addForm.a_id" @change="activitySelect" placeholder="请选择活动">
                <el-option v-for="item in activityList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
              </el-select>
            </el-form-item> -->

            <el-form-item label="商品分类" prop="type">
              <el-select v-model="addForm.type" @change="handleCommissioer" placeholder="请选择分类">
                <el-option v-for="item in catelist" :key="item.id" :label="item.name" :value="item.id"> </el-option>
              </el-select>
            </el-form-item>

            <!-- <el-form-item label="低温商品截止时间" v-if="addForm.type == 2" label-width="150px">
              星期：
              <el-select v-model="addForm.dwReserveWeek" placeholder="请选择星期">
                <el-option v-for="item in weeklist" :key="item.id" :label="item.name" :value="item.id"> </el-option>
              </el-select>
              <el-time-select
                v-model="addForm.dwReserveHour"
                :picker-options="{
                  start: '06:00',
                  step: '01:00',
                  end: '24:00',
                }"
                placeholder="选择几点截止"
              >
              </el-time-select>
            </el-form-item> -->
          </el-tab-pane>

          <!-- <el-tab-pane label="商品属性" name="2">
            <el-form-item :label="item.attr_name" v-for="item in onlyTableData" :key="item.attr_id">
              <el-input v-model="item.attr_vals"></el-input>
            </el-form-item>
          </el-tab-pane> -->

          <el-tab-pane label="商品图片" name="1">
            <!-- action 表示图片要上传到的后台API地址 -->
            <el-upload
              :action="uploadURL"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              list-type="picture"
              name="images"
              :limit="1"
              :headers="headerObj"
              :file-list="addForm.fengmian"
              :on-success="handleSuccess"
            >
              <el-button size="small" type="primary">上传封面图(最多1张,最佳尺寸宽高比为2：1)</el-button>
            </el-upload>

            <el-upload
              :action="uploadURL"
              :on-preview="lunbohandlePreview"
              :on-remove="lunbohandleRemove"
              list-type="picture"
              name="images"
              :limit="5"
              :headers="headerObj"
              :file-list="addForm.pics"
              :on-success="lunbohandleSuccess"
              class="lunboUpload"
            >
              <el-button size="small" type="primary">上传轮播图(最多5张,最佳尺寸宽高比为2：1)</el-button>
            </el-upload>
          </el-tab-pane>

          <el-tab-pane label="商品详情" name="2">
            <!-- 富文本编辑器组件 -->
            <!-- <quill-editor v-model="addForm.content"></quill-editor> -->
            <el-upload
              class="avatar-uploader"
              action="https://hsapi.sqmilk.com/common/uploads"
              :file-list="fileList"
              :on-success="contentuploadSuccess"
              :on-error="contentuploadError"
              :before-upload="contentbeforeUpload"
              list-type="picture"
              :show-file-list="false"
              name="images"
              :limit="100"
            >
            </el-upload>

            <quill-editor v-model="addForm.content" ref="myQuillEditor" :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @change="onEditorChange($event)">
            </quill-editor>

            <!-- 添加商品的按钮 -->
            <el-button type="primary" v-if="addForm.id == 0" class="btnAdd" @click="add">添加商品</el-button>
          </el-tab-pane>
          <el-button type="primary" v-if="addForm.id > 0" class="btnAdd" @click="editSave">保存</el-button>
        </el-tabs>
      </el-form>
    </el-card>

    <!-- 图片预览 -->
    <el-dialog title="图片预览" :visible.sync="previewVisible" width="50%">
      <img :src="previewPath" alt="" class="previewImg" />
    </el-dialog>
  </div>
</template>

<script>
// 工具栏配置
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'], // toggled buttons
  ['blockquote', 'code-block'],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
  [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
  [{ direction: 'rtl' }], // text direction

  [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ['image'],
  ['clean'], // remove formatting button
]

import _ from 'lodash'
export default {
  data () {
    return {
      options: [
        {
          id: 1,
          label: '件'
        },
         {
          id: 2,
          label: '组'
        },
        {
          id: 3,
          label: '瓶'
        },
        {
          id: 4,
          label: '盒'
        },
        ],
        xuebiao:[
          {id:1,label:'是'},
          {id:2,label:'否'},
        ],
        jxtypelist:[
          {id:1,label:'团购'},
          {id:2,label:'校园'},
          {id:3,label:'全渠道'},
          {id:4,label:'特渠'},
        ],
      weeklist: [
        { name: '一', id: 1 },
        { name: '二', id: 2 },
        { name: '三', id: 3 },
        { name: '四', id: 4 },
        { name: '五', id: 5 },
        { name: '六', id: 6 },
        { name: '日', id: 7 },
      ],

      activeIndex: '0',

      // 添加商品的表单数据对象
      addForm: {
        id: 0,
        title: '',
        unit: 1,
        radio:1,
        school_sign: 2,
        // desc: '',
        number: null,
        // warnNum: null,
        // kucun: null,
        preNum: null,
        weight: null,
        price: null,
        level: null,
        price1: null,
        price2: null,
        price3: null,
        // a_id: '',
        // 商品所属的分类数组
        type: [],
        // 图片的数组
        pics: [],
        // 商品的详情描述
        content: '',
        fengmian: [],
        // attrList: [],//规格数据
        // dwReserveWeek: 0,
        // dwReserveHour: 0,
      },

      addFormRules: {
        title: [
          { required: true, message: '请输入商品名称', trigger: 'blur' }
        ],
        number: [
          { required: true, message: '请输入商品编号', trigger: 'blur' }
        ],
        preNum: [
          { required: true, message: '请输入商品每件数量', trigger: 'blur' }
        ],
        weight: [
          { required: true, message: '请输入商品重量', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入商品价格', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择商品分类', trigger: 'blur' }
        ],
        // level: [
        //   { required: true, message: '请输入用户级别', trigger: 'blur' }
        // ],
        // price1: [
        //   { required: true, message: '请输入商品一级价格', trigger: 'blur' }
        // ],
        // price2: [
        //   { required: true, message: '请输入商品二级价格', trigger: 'blur' }
        // ],
        // price3: [
        //   { required: true, message: '请输入商品三级价格', trigger: 'blur' }
        // ]
      },
      // 商品分类列表
      catelist: [],
      activityList: [],
      value: '',
      cateProps: {
        label: 'cat_name',
        value: 'cat_id',
        children: 'children'
      },
      // 动态参数列表数据
      manyTableData: [],
      // 静态属性列表数据
      onlyTableData: [],
      // 上传图片的URL地址
      uploadURL: 'https://hsapi.sqmilk.com/common/uploads',
      // 图片上传组件的headers请求头对象
      headerObj: {
        Authorization: window.sessionStorage.getItem('token')
      },
      previewPath: '',
      previewVisible: false,
      // 上传的图片
      fileList: [],
      editorOption: {
        placeholder: '请输入内容',
        theme: 'snow', // or 'bubble'
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function (value) {
                if (value) {
                  // 触发input框选择图片文件
                  document.querySelector('.avatar-uploader input').click()
                } else {
                  this.quill.format('image', false)
                }
              },
            },
          },
        },
      },

      // 控制添加规格
      // addCateDialogVisible: false,
      // addCateForm: {
      //   attr_num: '',
      //   attr_kucun: '',
      //   attr_weight: '',
      //   attr_price: '',
      // },
      // addCateFormRules: {
      //   attr_num: [{ required: true, message: '请输入规格量，如12盒', trigger: 'blur' }]
      //   , attr_kucun: [{ required: true, message: '请输入该规格库存', trigger: 'blur' }]
      //   , attr_weight: [{ required: true, message: '请输入该规格重量', trigger: 'blur' }]
      //   , attr_price: [{ required: true, message: '请输入该规格价格', trigger: 'blur' }]
      // },
      // editDialogVisible: false,
      // editForm: {
      //   id: '',
      //   attr_num: '',
      //   attr_kucun: '',
      //   attr_weight: '',
      //   attr_price: '',
      // },

    }
  },

  created () {
    console.log(this.$route.query.id);
    if (this.$route.query.id > 0) {//编辑
      this.addForm.id = this.$route.query.id;
      this.getGoodDetail(this.$route.query.id);
    }
    this.getCateList()
    // this.getActivityList()
  },

  methods: {

    activitySelect (value) {
      console.log(value)
      this.addForm.a_id = value
    },

    handleCommissioer (value) {
      console.log(value)
    },

    // 点击按钮，展示添加规格的对话框
    // showAddCateDialog () {
    //   this.addCateDialogVisible = true
    // },
    // 展示编辑规格的对话框
    // async showEditDialog (id) {
    //   console.log(id)
    //   const { data: res } = await this.$http.get('admin/good/getAttrById', {
    //     params: { id: id }
    //   })
    //   if (res.code !== 200) {
    //     return this.$message.error('查询规格失败')
    //   }
    //   this.editForm = res.result
    //   this.editDialogVisible = true
    // },

    // editDialogClosed () {
    //   this.$refs.addCateFormRef.resetFields()
    // },

    // 点击按钮，添加新的规格
    // addCate () {
    //   this.$refs.addCateFormRef.validate(async valid => {
    //     if (!valid) return
    //     const { data: res } = await this.$http.post('admin/good/addGoodAttr', this.addCateForm)
    //     if (res.code !== 200) {
    //       return this.$message.error('添加规格失败！')
    //     }
    //     this.$message.success('添加规格成功！')
    //     this.addForm.attrList.push(res.result)
    //     this.addCateDialogVisible = false
    //   })
    // },

    // 编辑规格
    // editAttr (id) {

    //   this.$refs.addCateFormRef.validate(async valid => {
    //     if (!valid) return
    //     const { data: res } = await this.$http.post('admin/good/editAttr', this.editForm)
    //     if (res.code !== 200) {
    //       return this.$message.error('编辑失败！')
    //     }
    //     this.$message.success('编辑成功！')
    //     const i = this.addForm.attrList.findIndex(x => x.id === this.editForm.id)
    //     this.addForm.attrList.splice(i, 1)
    //     this.addForm.attrList.push(res.result)
    //     this.editDialogVisible = false
    //   })
    // },

    // 监听对话框的关闭事件，重置表单数据
    // addCateDialogClosed () {
    //   this.$refs.addCateFormRef.resetFields()
    // },

    // 获取所有商品分类数据
    async getCateList () {
      const { data: res } = await this.$http.get('admin/good/type')
      if (res.code !== 200) {
        return this.$message.error('获取商品分类数据失败！')
      }
      this.catelist = res.result
      console.log(this.catelist)
    },

    // 获取所有活动
    async getActivityList () {
      const { data: res } = await this.$http.get('admin/activity/getAllActivityInUse')
      if (res.code !== 200) {
        return this.$message.error('暂无有效活动可选择！')
      }
      this.activityList = res.result
    },

    // 获取商品规格数据
    // async getAttrList () {
    //   const { data: res } = await this.$http.get('admin/good/getAttrs', {
    //     params: this.querInfo
    //   })

    //   if (res.code !== 200) {
    //     return this.$message.error('获取商品规格失败！')
    //   }

    //   console.log(res.result)
    //   // 把数据列表，赋值给 catelist
    //   this.addForm.attrList = res.result.list

    // },

    // 根据Id删除对应的规格信息
    // async removeAttrById (id) {
    //   const confirmResult = await this.$confirm(
    //     '此操作将删除该规格, 是否继续?',
    //     '提示',
    //     {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //     }
    //   ).catch(err => err)
    //   if (confirmResult !== 'confirm') {
    //     return this.$message.info('已取消删除')
    //   }
    //   const i = this.addForm.attrList.findIndex(x => x.id === id)
    //   this.addForm.attrList.splice(i, 1)
    // },

    // 获取所有商品详情
    async getGoodDetail (id) {
      const { data: res } = await this.$http.get('admin/good/detail', {
        params: {
          id: id
        }
      })
      if (res.code !== 200) {
        return this.$message.error('获取商品信息失败！')
      }
      this.addForm = res.result
      console.log(this.addForm)
    },

    beforeTabLeave (activeName, oldActiveName) {
      if (oldActiveName === '0' && this.addForm.title.length == 0) {
        this.$message.error('请输入商品名称！')
        return false
      }
      else if (oldActiveName === '0' && this.addForm.number.length == 0) {
        this.$message.error('请输入商品编码！')
        return false
      }
      else if (oldActiveName === '0' && this.addForm.type.length == 0) {
        this.$message.error('请先选择商品分类！')
        return false
      }
      // else if (oldActiveName === '0' && this.addForm.dwReserveWeek == 0 && this.addForm.type == 2) {
      //   this.$message.error('低温商品选择截止周几！')
      //   return false
      // } else if (oldActiveName === '0' && this.addForm.dwReserveHour.length == 0 && this.addForm.type == 2) {
      //   this.$message.error('低温商品选择截止时间！')
      //   return false
      // }


    },

    async tabClicked () {
      console.log(this.activeIndex)

    },
    // 处理图片预览效果
    handlePreview (file) {
      console.log(file)
      this.previewPath = file.url
      this.previewVisible = true
    },

    // 处理移除图片的操作
    handleRemove (file) {
      const filePath = file.url
      const i = this.addForm.fengmian.findIndex(x => x.url === filePath)
      this.addForm.fengmian.splice(i, 1)
    },

    // 监听图片上传成功的事件
    handleSuccess (response) {
      const picInfo = { url: response.result.show }
      this.addForm.fengmian.push(picInfo)
    },

    // 轮播图片预览效果
    lunbohandlePreview (file) {
      this.previewPath = file.url
      this.previewVisible = true
    },

    // 轮播图片移除的操作
    lunbohandleRemove (file) {
      // console.log(file)
      const filePath = file.url
      const i = this.addForm.pics.findIndex(x => x.url === filePath)
      this.addForm.pics.splice(i, 1)
      // console.log(this.addForm)
    },

    // 轮播图片上传成功的事件
    lunbohandleSuccess (response) {
      console.log(response)
      // 1. 拼接得到一个图片信息对象
      const picInfo = { url: response.result.show }
      // 2. 将图片信息对象，push 到pics数组中
      this.addForm.pics.push(picInfo);
      console.log(this.addForm)
    },

    // 添加商品
    add () {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) {
          return this.$message.error('请填写必要的表单项！')
        }
        if (this.addForm.fengmian.length == 0) {
          return this.$message.error('请上传封面图')
        }
        const form = _.cloneDeep(this.addForm)
        const { data: res } = await this.$http.post('admin/good/add', form)
        if (res.code !== 200) {
          return this.$message.error('添加商品失败！')
        }
        this.$message.success('添加商品成功！')
        this.$router.push('/goods')
      })
    },

    //编辑保存
    async editSave () {
      // 发起请求添加商品
      // 商品的名称，必须是唯一的
      const form = _.cloneDeep(this.addForm)
      const { data: res } = await this.$http.post('admin/good/edit', form)
      if (res.code !== 200) {
        return this.$message.error('修改商品失败！')
      }
      this.$message.success('修改商品成功！')
      this.$router.push('/goods')
    },
    // 富文本相关方法
    onEditorReady (editor) {
      // 准备编辑器
    },
    onEditorBlur () { }, // 失去焦点事件
    onEditorFocus () { }, // 获得焦点事件
    // 内容改变事件
    onEditorChange ({ editor, html, text }) {
      console.log(html);
      this.addForm.content = html;
    },

    // 富文本图片上传前
    contentbeforeUpload () {
      // 显示loading动画
    },

    contentuploadError () { },

    contentuploadSuccess (response, file) {
      console.log(response)
      // response为图片服务器返回的数据
      try {
        // 获取富文本组件实例
        let quill = this.$refs.myQuillEditor.quill
        // 如果上传成功
        if (response.code == '200') {
          // 获取光标所在位置
          let length = quill.getSelection().index
          // 插入图片  res.info为服务器返回的图片地址
          quill.insertEmbed(length, 'image', response.result.show)
          // 调整光标到最后
          quill.setSelection(length + 1)
        } else {
          this.$message.error('图片插入失败')
        }
      } catch (e) {
        console.log(e)
        this.$message.error('图片插入失败')
      } finally {
        // loading动画消失
      }
    },

  },
  computed: {
    editor () {
      return this.$refs.myQuillEditor.quill
    },
  },
}
</script>

<style lang="less" scoped>
.tip {
  color: #999999;
  font-size: 16px;
}
.lunboUpload {
  margin-top: 40px;
}
.el-checkbox {
  margin: 0 10px 0 0 !important;
}

.previewImg {
  width: 100%;
}

.btnAdd {
  margin-top: 15px;
}
</style>
